import { createContext, useContext } from 'react'
import { ThemeState } from '../model/types'

export const ThemeContext = createContext<ThemeState | undefined>(undefined)

export const useThemeContext = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useThemeContext must be used within a ThemeProvider')
  }
  return context
}
